import { MedicineSimple } from '@dreryk/drerykweb-medicine-api';

import { createGlobalState } from '~libs.ui.react';

import { MedicineId } from '../types';

export type MedicineSelectionMapGlobalState = Map<MedicineId, MedicineSimple[]>;

export const useMedicineSelectionMapGlobalState = createGlobalState<MedicineSelectionMapGlobalState>(new Map());
